import {loadProductIntoScene} from "./viewerHooks/internal/loadProduct";
import {ThreeViewer} from "./viewerHooks/internal/ThreeViewer";
import {RGBELoader} from "three/addons/loaders/RGBELoader";
import * as THREE from "three";

const initialize3dObject = async ({ product, status, setStatus, setProduct, formData }) => {
    const data = product
    const container = document.getElementById("mainCanvas");
    if(window.threeViewer) {
        window.threeViewer.dispose()
        window.threeViewer = null
    }
    
    if (container) {
        const threeViewer = new ThreeViewer({
            element: container,
        })
        await threeViewer.initViewer()
        
        const rgbLoader = new RGBELoader().setPath('/hdr/');
        const envMapTexture = await rgbLoader.loadAsync('marry_hall_1k-saturated.hdr');
        envMapTexture.mapping = THREE.EquirectangularReflectionMapping;
        threeViewer.scene.environment = envMapTexture;
        threeViewer.renderer.toneMapping = THREE.LinearToneMapping;
        threeViewer.renderer.toneMappingExposure = 0.4;
        
        // Model Setup
        const product = await loadProductIntoScene(formData.objectFile, threeViewer);
        
        // If no sections are present, fit the camera to the product
        if(!(data?.sections?.length > 0)) {
            threeViewer.controls.fitToBox(product, true)
        }
        let size = new THREE.Vector3()
        let boundingBox = new THREE.Box3().setFromObject(product)
        boundingBox.getSize(size)
        setProduct({
            ...data,
            size: size,
            colorObject: product.userData.colorObject,
            center: Math.max(size.x, size.y) / 2,
        })

        setStatus({
            ...status,
            initialized: true
        })
        window.threeViewer = threeViewer;

        setTimeout(() => {
            threeViewer.setWindowResize()
        }, 1500); // TODO : Need to find a better way to handle this
    }
}
export default initialize3dObject